import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
    selector: 'app-pb-contact-form',
    templateUrl: './pb-contact-form.component.html',
    styleUrls: ['./pb-contact-form.component.scss']
})
export class PbContactFormComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    paddingTop: any = '';
    paddingBottom: any = '';
    items: any = [];
    contactForm;

    firstName: any = '';
    lastName: any = '';
    emailAddress: any = '';
    phoneNumber: any = '';
    bookingReference: any = '';
    message: any = '';
    subscribe: any = '';
    enquiryType: any = '';

    processing = false;
    success = false;
    options: any = [];

    constructor(private cd: ChangeDetectorRef, private api: ApiService, private formBuilder: FormBuilder, private router: Router) {

        this.contactForm = this.formBuilder.group({
            firstName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            lastName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            emailAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
            ])),
            phoneNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[0-9]*$'),
            ])),
            bookingReference: new FormControl(''),
            enquiryType: new FormControl('', Validators.compose([
                Validators.required
            ])),
            subscribe: new FormControl(''),
            message: new FormControl('', Validators.compose([
                Validators.required
            ])),
        });

    }

    ngOnInit(): void {

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            };

            this.items.push(item);
        });

        this.paddingTop = this.module.paddingTop; // Module Padding
        this.paddingBottom = this.module.paddingBottom;

        this.getFormOptions();

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    saveChanges() {

        if (!this.contactForm.valid) {
            Object.keys(this.contactForm.controls).forEach(field => {
                const control = this.contactForm.get(field);
                control.markAsTouched({ onlySelf: true });
            });

            return false;
        }

        let user: any = localStorage.getItem('user');
        let userAccountKey: any = '';

        if (user) {
            try {
                user = JSON.parse(user);
                userAccountKey = user.Result.UserAccountKey._text;
            } catch (err) { }
        }

        const gaUserId = document.cookie.match(/_ga=(.+?)(?:;|$)/)?.[1].split('.').slice(-2).join('.');

        const contactFrm = this.contactForm.getRawValue();
        const data = {
            firstName: contactFrm.firstName,
            lastName: contactFrm.lastName,
            emailAddress: contactFrm.emailAddress,
            phoneNumber: contactFrm.phoneNumber,
            message: contactFrm.message,
            bookingReference: contactFrm.bookingReference,
            enquiryType: contactFrm.enquiryType,
            subscribe: contactFrm.subscribe,

            // UTM Variables

            formName: 'General Contact',
            utmSource: sessionStorage.getItem('utmSource'),
            utmMedium: sessionStorage.getItem('utmMedium'),
            utmCampaign: sessionStorage.getItem('utmCampaign'),
            utmContent: sessionStorage.getItem('utmContent'),
            utmTerm: sessionStorage.getItem('utmTerm'),
            clientId: gaUserId,
            userId: userAccountKey
        };

        this.submitToApi(data);

    }

    async submitToApi(data) {

        this.processing = true;
        this.success = false;

        const redirectUrl = this.module.prebuilt_module_data.redirect_url ? this.module.prebuilt_module_data.redirect_url : false;

        await this.api.submit_contact_form_data(data)
            .subscribe(res => {
                this.processing = false;
                this.cd.detectChanges();

                this.contactForm.reset();
                this.success = true;

                if (redirectUrl) {
                    this.router.navigateByUrl(redirectUrl);
                }
            }, (err) => {
                this.processing = false;
                this.cd.detectChanges();

                Swal.fire({
                    title: 'Error',
                    text: 'Unable to send your message',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showCloseButton: true,
                    customClass: 'swal-ibtc',
                    position: 'top'
                }).then((result) => {
                });
            });

    }

    /**
     * Easier access to the controlname reference
     */
    get f() {

        return this.contactForm.controls;

    }

    async getFormOptions() {

        await this.api.fetch_form_options()
            .subscribe(res => {
                this.options = res.data.items;
            }, (err) => {

            });

    }

}
